<div class="flex flex-col flex-auto min-w-0">
    <app-drake-grid [scope]="scope" [viewCode]="viewCode" [filter]="filter" [sort]="sort" [template]="template"></app-drake-grid>
</div>